<template>
  <div class="city-container">
      <div class="box" v-if='tag' @click="getFoucs">{{content}}</div>
      <!--:getPopupContainer="triggerNode => triggerNode.parentNode"-->
      <a-cascader :defaultValue="tvalue"   :options="options" ref='cas' :popupVisible='visibleValue' @popupVisibleChange='onVisible' @change="onChange" :loadData="loadData"  placeholder="请选择省市" />
  </div>
</template>

<script>
import { constants } from 'crypto';
export default {
  props: {
    areaRecord: {
      type: Object,
      default: {}
    },
    recordIndex: {
      type: Number,
      default: ""
    },
    // desc: {
    //   type: String,
    //   default: ""
    // }
  },
//   watch: {
//     visible(val) {
//       this.visibleValue = val;
//     }
//   },
  data() {
    return {
      visibleValue: false,
      tag: true,
      content:'',
    //   tvalue:['北京市','市辖区','东城区'],
     tvalue:['110000'],
     isAuto:false,
      newData:[],
      newValue:'',
       options: [{
        value: 'zhejiang',
        label: 'Zhejiang',
        isLeaf: false,
      }, {
        value: 'jiangsu',
        label: 'Jiangsu',
        isLeaf: false,
      }]
    };
  },
  methods: {
      getFoucs(){
        this.visibleValue = true
      },
    getProvince(){
    let _this = this
    let provinceList = JSON.parse(sessionStorage.getItem('provinceList'))
    if(provinceList){
     this.newData = provinceList
     this.provinceData()
    }else{
        this.$get('area/province/list').then(res=>{
        this.newData = res.data.data
         this.provinceData()
         sessionStorage.setItem('provinceList', JSON.stringify(this.newData))
         
     }) 

    }
    //   this.tvalue=['110000','110100','110102']
    setTimeout(()=>{
    //  _this.tvalue=['110000']
    _this.tvalue=['110000']
    },5000)

    },
    provinceData(data){
       this.newData.map(item=>{
           item.value = item.provinceID
           item.label = item.province
           item.type = 'province'
           item.isLeaf = false
           return item
       })
       this.options = JSON.parse(JSON.stringify(this.newData))
    },
    getCity(data){
     this.$get('area/city/list',{
         fatherID:data
     }).then(res=>{
     })
    },
    onVisible(value){
     this.visibleValue = value
    },
   onChange(value,data) {
      this.tag = false
      this.value = value
      if(value.length==3){
          let recodData = {
              areaRecord:this.areaRecord,
              index:this.recordIndex,
              valueData: value
          }

        this.$emit('watchCity', recodData)
      }
    },
    loseValue(){
      if(this.value.length!=3){
        this.$message.error('请把籍贯填写完整')
      }
    },
    loadData(selectedOptions) {
      let _this = this
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      // load options lazily
      setTimeout(() => {
        targetOption.loading = false;
        if(targetOption.type == 'province'){
             this.$get('area/city/list',{
                    fatherID: targetOption.provinceID
                }).then(res=>{
                    let cityData = res.data.data
                    cityData.map(item=>{
                         item.value = item.cityID
                        item.label = item.city
                        item.type = 'city'
                        item.isLeaf = false
                        return item
                    })
              targetOption.children = cityData
              this.options = [...this.options]
            })
         }else if(targetOption.type == 'city'){
               this.$get('/area/area/list',{
                    fatherID: targetOption.cityID
                }).then(res=>{
                    let countryData = res.data.data
                    countryData.map(item=>{
                         item.value = item.areaID
                        item.label = item.area
                        item.type = 'country'
                        item.isLeaf = true
                        return item
                    })
              targetOption.children = countryData
              this.options = [...this.options]
            })

         }
        // targetOption.children = [{
        //   label: `${targetOption.label} Dynamic 1`,
        //   value: 'dynamic1',
        //   isLeaf:false,
        // }, {
        //   label: `${targetOption.label} Dynamic 2`,
        //   value: 'dynamic2',
        //   isLeaf:false,
        // }];
        // this.options = [...this.options]
      }, 1000);
    }
  },
  created(){
      if(this.areaRecord.provinceName){
        this.content= this.areaRecord.provinceName
        if(this.areaRecord.cityName){
            this.content= this.areaRecord.provinceName + '/' + this.areaRecord.cityName
            if(this.areaRecord.countryName){
                this.content= this.areaRecord.provinceName + '/' + this.areaRecord.cityName + '/'+ this.areaRecord.countryName
            }
        }
      }
      
    this.getProvince()
  }
};
</script>

<style lang="scss" scoped>
.city-container{
    width: 220px;
    height: 32px;
    position: relative;
    .box{
      position: absolute;
      width: 220px;
    //   padding-right: 30px;
      font-size: 12px;
      padding-left: 10px;
      cursor: pointer;
      color: rgba(0, 0, 0, 0.25);
      height: 32px;
      line-height: 32px;
      background: transparent;
      z-index: 999;
      top: 0;
      left: 0;
    }
    .ant-cascader-picker{
        display: inline-block;
        width: 220px;
    }
}
</style>